module.exports = __webpack_public_path__ + "static/rainbowmain-1cbf15ee1e743d7f941471d7779951b5.png";